import { every, get } from "lodash";
import store from "./index";

function userFactory(api) {
  const idAttribute = "userId";

  return {
    actions: {
      async create({ commit, dispatch, state }, attributeHash) {
        const record = await api.create(attributeHash);
        commit("setRecord", record);
        await dispatch("list");

        return state.record;
      },
      async get({ commit, state }, id) {
        const record = await api.get(id);
        commit("setRecord", record);

        return state.record;
      },
      async list({ commit, state }, { reload = true } = { reload: true }) {
        if ((!state.list.length && !state.listPromise) || reload) {
          commit("setListPromise", api.list());
          const list = await state.listPromise;
          commit("setList", list);
          commit("setListPromise", null);
        } else if (state.listPromise) {
          await state.listPromise;
        }
        return state.list;
      },
      async listAdmin({ commit }) {
        const list = await api.listAdmin();
        return commit("setListAdmin", list);
      },
      async remove({ dispatch }, id) {
        await api.remove(id);
        await dispatch("list");

        return true;
      },
      async update({ commit, dispatch, state }, [id, data]) {
        const record = await api.update(id, data);

        commit("setRecord", record);
        await dispatch("list");

        return state.record;
      },
    },
    getters: {
      filter: state => (filterMap, id) => {
        if (id) {
          filterMap = Object.assign({}, filterMap, { [idAttribute]: id });
        }

        const filteredList = state.list.filter(item => {
          return every(filterMap, (filterValue, filterAttribute) => {
            return get(item, filterAttribute) === filterValue;
          });
        });

        return filteredList;
      },
      find: state => (filterMap, id) => {
        if (id) {
          filterMap = Object.assign({}, filterMap, { [idAttribute]: id });
        }

        return state.list.find(item => {
          return every(filterMap, (filterValue, filterAttribute) => {
            return item[filterAttribute] === filterValue;
          });
        });
      },
      filterByAttributeValue: state => (attribute, value, joinList) => {
        if (!attribute) {
          return [];
        }

        const filteredList = state.list.filter(item => {
          if (item[attribute] === undefined) {
            return false;
          }

          return item[attribute] === value;
        });

        if (Array.isArray(joinList) && joinList.length) {
          filteredList.forEach(item => {
            joinList.forEach(join => {
              const getter = store.getters[`${join.entity}/getById`];
              const record = getter(item[join.attribute]);
              item[join.entity] = record;
            });
          });
        }

        return filteredList;
      },
      getById: state => findId => {
        if (typeof findId === "undefined") return undefined;
        const user = state.list.find(item => {
          return item[idAttribute] === findId;
        });
        return user;
      },
      getByEntraId: state => findId => {
        return state.list.find(item => {
          return item.entraId === findId;
        });
      },
      getByIdAdmin: state => findId => {
        return state.listAdmin.find(item => {
          return item[idAttribute] === findId;
        });
      },
    },
    mutations: {
      setAttribute(state, [entityId, attribute, value]) {
        const entity = state.list.find(
          entity => entity[idAttribute] === entityId
        );

        if (!entity) {
          throw new Error(`No ${idAttribute} with id of ${entityId}`);
        }

        entity[attribute] = value;
      },
      setList(state, list) {
        state.list = list;
      },
      setListAdmin(state, list) {
        state.listAdmin = list;
      },
      setListPromise(state, value) {
        state.listPromise = value;
      },
      setRecord(state, record) {
        state.record = record;
      },
    },
    namespaced: true,
    state: {
      list: [],
      listAdmin: [],
      listPromise: null,
      record: {},
    },
  };
}

export default userFactory;
